import { SxProps, Theme } from '@mui/material';

export const popupMenuStyles = {
  container: (_theme: Theme) =>
    ({
      display: 'inline-flex',
      alignItems: 'center',
    }) as SxProps<Theme>,

  trigger: (theme: Theme) =>
    ({
      width: '36px',
      height: '32px',
      padding: theme.spacing(0.5),
      borderRadius: `${theme.shape.borderRadius}px`,
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '2px',
      },
    }) as SxProps<Theme>,

  icon: (_theme: Theme) =>
    ({
      width: '24px',
      height: '16px',
      display: 'block',
    }) as SxProps<Theme>,

  paper: (theme: Theme) =>
    ({
      minWidth: '140px',
      boxShadow: theme.shadows[4],
      borderRadius: `${theme.shape.borderRadius}px`,
      marginTop: theme.spacing(0.5),
    }) as SxProps<Theme>,

  menuItem: (theme: Theme) =>
    ({
      fontSize: theme.typography.body2.fontSize,
      color: theme.palette.text.primary,
      minHeight: '32px',
      padding: theme.spacing(0.75, 2),
    }) as SxProps<Theme>,
};

export const popupMenuProps = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
};

export default popupMenuStyles;
